import Vue from "vue";
import axios from "axios";

const $http = axios.create();

Vue.prototype.$http = axios;
const token = localStorage.getItem("token");
axios.defaults.baseURL =
  process.env.VUE_APP_API_URL || "http://192.168.1.9:3000";
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${token}`;
}

export default $http;
